import React, { useRef, useEffect } from 'react';
const TrustBox = ({getLanguageCode}) => {

  const lang = getLanguageCode("Atd");
  const locale = lang === "de" ? "de-DE" : "en-GB";

  // Create a reference to the <div> element which will represent the TrustBox
  const ref = useRef(null);
  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  },[]);
  return (
    <div
      ref={ref} // We need a reference to this element to load the TrustBox in the effect.
      className="trustpilot-widget"
      data-locale={locale}
      data-template-id="5419b637fa0340045cd0c936"
      data-businessunit-id="5e5e88cd57d9200001c067ba"
      data-style-height="20px"
      data-style-width="100%"
      data-theme="light"
    >
      <a href="https://uk.trustpilot.com/review/www.attractiontickets.com" target="_blank" rel="noopener">Trustpilot</a>
    </div>
  );
};
export default TrustBox;